import { Routes } from '@angular/router';
import { googleMapsResolver } from '../../../core/auth/resolvers/google-maps.resolver';

export const TrackingRoutes: Routes = [
  {
    path: 'tracking',
    loadComponent: () =>
      import('./tracking.component').then(m => m.TrackingComponent),
    data: {
      animation: 'tracking',
      title: 'Tracking',
    },
  },
  {
    path: 'gps-playback/:rideId',
    resolve: { googleMapsLoaded: googleMapsResolver },
    loadComponent: () =>
      import('./pages/gps-playback/gps-playback.component').then(m => m.GpsPlaybackComponent),
    data: {
      animation: 'gps-playback',
      title: 'GPS Playback',
    },
  },
];
